export default class PerformanceManagementService {
    constructor($http, appConfig) {
      "ngInject";
  
      this.$http = $http;
      this.appConfig = appConfig;
    }

    addMonthlyDistribution(monthlyDistribution) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + `api/performancemanagement/addmonthlydistribution/`, monthlyDistribution);
    } 
    
    listMonthlyDistribution(entityId, year) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + `api/performancemanagement/listmonthlydistribution/${entityId}/${year}`);
    }  
    
    editMonthlyDistribution(monthlyDistribution) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + `api/performancemanagement/editmonthlydistribution/`, monthlyDistribution);
    } 

    removeMonthlyDistribution(entityId, monthlyDistributionId) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + `api/performancemanagement/removemonthlydistribution/${entityId}/${monthlyDistributionId}`);
    }  
    
    addUserTarget(userTarget) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + `api/performancemanagement/addusertarget/`, userTarget);
    }     

    listUserTargets(entityId, year) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + `api/performancemanagement/listusertargets/${entityId}/${year}`);
    }  
    
    editUserTarget(userTarget) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + `api/performancemanagement/editusertarget/`, userTarget);
    } 

    removeUserTarget(entityId, userTargetId) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + `api/performancemanagement/removeusertarget/${entityId}/${userTargetId}`);
    }  

    getTargetsOverview(criteria) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + `api/performancemanagement/getTargetsOverview`, criteria);
    }
  }


// WEBPACK FOOTER //
// ./client/app/common/services/performanceManagementService.js